import React from 'react'
import Modal from './Modal'
import Feedback from './feedback'
import { Info } from '../assets/icons'
import theme from '../styled/theme'

const CancelAppointmentConfirmModal = ({
	isOpen,
	onClose,
	onConfirm,
	isFullHeight,
	title = '¿Estás seguro que queres cancelar tu turno?',
	bodyText = 'Si cancelás este turno, vas a tener que reservar uno nuevo.',
	confirmLabel = 'Sí, cancelar turno',
	cancelLabel = 'Volver'
}) => {
	if (!isOpen) return null

	return (
		<Modal onClose={onClose} isFullHeight={isFullHeight} widthDesktop="480px" >
			<Feedback
				title={title}
				bodyText={bodyText}
				buttonLabel={confirmLabel}
				secondaryButtonLabel={cancelLabel}
				onClickButton={onConfirm}
				onClickSecondaryButton={onClose}
				isSuccess={false}
				isError={false}
				icon={<Info color={theme.colors.brand.lightBlue} />}
				isModal={true}
				pt={80}
				widthDesktop="480px"
			/>
		</Modal>
	)
}

export default CancelAppointmentConfirmModal